export const REQUISITION_COOKIE_NAME = 'requisition';
